import { MOCK_CHANGELOGS } from '../mock-data/index.js';
import { delay } from '../utils/helpers.js';

export class ChangelogService {
	constructor(baseAPI) {
		this.api = baseAPI;
	}

	async getChangelogs(options = {}) {
		await this.api._ensureSession();

		if (this.api.mock) {
			await delay(300);
			return { success: true, data: MOCK_CHANGELOGS };
		}

		return this.api._handleAuthRetry(async () => {
			const endpoint = this.api._getEndpointWithParams(
				'/widget/changelogs',
				options
			);
			return await this.api._makeRequest(endpoint, {
				method: 'GET',
				headers: { Authorization: `Bearer ${this.api.sessionToken}` },
			});
		});
	}
}
